import React from "react";

import { uniqBy } from "shared/lib/functions";

import FormattedMessage from "@components/UI/FormattedMessage";

import Popover from "../UI/Popover";
import ChangeTicketPassengerDetail from "./ChangeTicketPassengerDetail";

type PassengerChangeCondition = {
  PassengerType: string;
  MinimumStay: {
    Stay: string;
    StayUnit: string;
  };
  MaximumStay: {
    Stay: string;
    StayUnit: string;
  };
  FlightCancelCondition: {
    Amount: string;
    AmountType: string;
  };
  FlightChangeCondition: {
    Amount: string;
    AmountType: string;
  };
};

type Props = {
  passengerChangeConditions: [PassengerChangeCondition];
};

function ChangeTicket({ passengerChangeConditions }: Props) {
  let showChangeConditions = true;
  passengerChangeConditions.forEach((passengerType) => {
    const keys = Object.keys(passengerType);
    if (keys.length === 1 && keys[0] === "PassengerType") {
      showChangeConditions = false;
    }
  });

  if (!showChangeConditions) {
    return null;
  }

  return (
    <div className="change-ticket" style={{ position: "relative" }}>
      <h3 className="h3 result-h3 ">
        <FormattedMessage id="ChangeTicket.ticketConditions" />
      </h3>
      <div className="result-box" style={{ marginBottom: 20 }}>
        <Popover
          component={
            <span
              id="change-tickets-toggle"
              className="link pointer noselect"
              role="button"
            >
              <FormattedMessage id="ChangeTicket.openConditions" />
            </span>
          }
          content={
            <div style={{ position: "relative" }}>
              <span
                style={{ position: "absolute", right: 3, top: -3 }}
                className="pointer"
                role="button"
                id="change-tickets-close"
              >
                X
              </span>
              {uniqBy(passengerChangeConditions, "PassengerType").map(
                (passengerChangeCondition, index) => (
                  <ChangeTicketPassengerDetail
                    key={index}
                    passengerChangeCondition={passengerChangeCondition}
                  />
                )
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}

export default ChangeTicket;
